import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ContextLayout } from './contexts';
import GlobalStyle from './styles/GlobalStyles';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <ContextLayout>
      <App />
    </ContextLayout>
  </React.StrictMode>
);
reportWebVitals();
